import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ExcCoreModule, ExcTranslation} from 'exc-core-v2';
import {ExgDataListComponent, ExgModalService} from 'exc-controls-v2';
import {IExcDataFilter, IExcDataPaging, IExcDataSort} from 'exc-rest-v2';
import {IExcMetaInfo} from 'exc-rest-v2/lib/interfaces/IExcMetaInfo';
import {UserSettingsService} from '../../../../services/user-settings.service';

@Component({
  selector: 'app-sv-user-textvorlagen',
  templateUrl: './sv-user-textvorlagen.component.html',
  styles: []
})
export class SvUserTextvorlagenComponent extends ExcTranslation implements OnInit {
  @ViewChild('VCTBList', {read: ExgDataListComponent}) VCTBList!: ExgDataListComponent;

  private _data: any;

  @Input()
  set data(value: any) {
    this._data = value;
    this.reload();
  }
  get data(): any {
    return this._data;
  }

  excRestService = ExcCoreModule.Services().ExcRest;

  saving = false;

  form: {
    visible: boolean;
    row: {
      tbName: string;
      tbTextShort: string;
      tbText: string;
    };
  } = {
    visible: false,
    row: {
      tbName: '',
      tbTextShort: '',
      tbText: ''
    },
  };

  TBList = {
    selectKey: 'tbID',
    state: 1,
    selectedRow: undefined as any,
    searchValue: '',
    data: [] as any[],
    tableDefinition: [
      {caption: 'Name',    value: 'tbName',      fixed: false, align: 0, sort: 0, ordinal: 0, visible: true},
      {caption: 'Kurztext', value: 'tbTextShort', fixed: false, align: 0, sort: 0, ordinal: 0, visible: true},
    ] as any[],
    MetaInfo: {
      dataPaging: {pageNo: 0, pageSize: 25} as IExcDataPaging,
      dataSort: {} as IExcDataSort,
      dataFilter: {} as IExcDataFilter,
    } as IExcMetaInfo,
    paging: {pagingPage: 0, pagingEndRow: 0, pagingPageSize: 25, pagingTotalPages: 0, pagingTotalRows: 0, pagingStartRow: 0},
    isLoading: true,
    selectionChanged: (index: any) => {
      this.TBList.selectedRow = this.TBList.data[index];
    },
    pageChanged: (page: number) => {
      if (this.TBList.MetaInfo.dataPaging !== undefined) {
        this.TBList.MetaInfo.dataPaging.pageNo = page;
      }
      this.loadTBData();
    },
    search: (value: string) => {
      this.TBList.searchValue = value;
      if (this.TBList.MetaInfo.dataPaging) { this.TBList.MetaInfo.dataPaging.pageNo = 0; }
      this.loadTBData();
    },
    ready: () => {
      if (this.TBList.data.length === 0) {
        this.TBList.state = 2;
        if (this.VCTBList) { this.VCTBList.selectedRow = -1; }
      } else {
        this.TBList.state = 0;
        if (this.VCTBList) { this.VCTBList.selectedRow = 0; }
      }
      this.TBList.isLoading = false;
    },
    loadData: (incomingData: any, incomingPaging: any) => {
      this.TBList.isLoading = false;
      this.TBList.data = incomingData;
      this.TBList.paging = incomingPaging;
      this.TBList.ready();
    },
  };

  MCEinit: any = {
    base_url: './tinymce',
    suffix: '.min',
    inline: false,
    height: 400,
    resize: false,
    menubar: false,
    statusbar: false,
    plugins: ['paste'],

    valid_styles: {
      '*': 'font-weight,font-style,text-decoration,text-align,color,background-color'
    },
    content_style:
      '@import url(\'https://fonts.googleapis.com/css?family=Calibri\'); body { font-family: Calibri; font-size: 11pt; }',

    // beim Paste alle font-family/size hart entfernen
    paste_preprocess: (plugin: any, args: any) => {
      // args.content ist ein HTML-String
      args.content = args.content
        .replace(/font-family\s*:\s*[^;"']+;?/gi, '')
        .replace(/font-size\s*:\s*[^;"']+;?/gi, '')
        .replace(/<font[^>]*>/gi, '')
        .replace(/<\/font>/gi, '');
    },
    toolbar: false,
  };

  constructor(
    private modalService: ExgModalService,
    private userSettings: UserSettingsService
  ) {
    super();
  }

  ngOnInit(): void {
    this.reload();
  }

  reload(): void {
    if (this._data) {
      this.loadTBData();
    }
  }

  initTableDefinition(): void {
    this.TBList.tableDefinition = [
      {caption: 'Name',    value: 'tbName',      fixed: false, align: 0, sort: 0, ordinal: 0, visible: true},
      {caption: 'Kurztext', value: 'tbTextShort', fixed: false, align: 0, sort: 0, ordinal: 0, visible: true},
    ];
  }

  loadTBData(): void {
    this.TBList.state = 1;
    this.TBList.isLoading = true;
    this.excRestService
      .get(
        this.excRestService.computeUrl('UserTextbausteineR_List', {fts: this.TBList.searchValue}),
        {
          MetaInfo: {
            dataPaging: this.TBList.MetaInfo.dataPaging,
            dataSort:   this.TBList.MetaInfo.dataSort,
            dataFilter: this.TBList.MetaInfo.dataFilter,
          }
        }
      )
      .subscribe((data: any) => {
        if (data && data.success) {
          const list = (data?.data?.Textbaustein || []).map((item: any) => ({
            ...item,
            tbTextShortClone: item.tbTextShort,
            tbNameClone: item.tbName,
            tbTextClone: item.tbText,
            tbName: item.tbName?.length > 40 ? item.tbName.substring(0, 25) + '…' : item.tbName,
            tbTextShort: item.tbTextShort?.length > 80 ? item.tbTextShort.substring(0, 35) + '…' : item.tbTextShort
          }));
          const paging = {
            pagingPage: 0,
            pagingEndRow: list.length,
            pagingPageSize: 25,
            pagingTotalPages: 1,
            pagingTotalRows: list.length,
            pagingStartRow: 0
          };
          this.TBList.loadData(list, paging);
        }
      });
  }
  startCreate(): void {
    this.form.row = {tbName: '', tbTextShort: '', tbText: ''};
    this.form.visible = true;
  }

  save(ngForm: NgForm): void {
    if (ngForm.invalid || this.saving) {
      return;
    }
    this.saving = true;
    const row = this.form.row;
    this.excRestService
      .post(
        this.excRestService.computeUrl('UserTextbausteineC', null),
        {tbName: row.tbName, tbTextShort: row.tbTextShort, tbText: row.tbText}
      )
      .subscribe((ret: any) => {
        this.saving = false;
        if (ret.success) {
          this.form.visible = false;
          this.modalService.showToast('Textvorlage gespeichert', 'md-toast', 'far fa-check');
          this.loadTBData();
        }
      });
  }

  editorSave(row: any): void {
    this.excRestService
      .put(
        this.excRestService.computeUrl('UserTextbausteineU', {tbID: row.tbID}),
        {tbUPT: row.tbUPT,
          tbName: row.tbNameClone,
          tbText: row.tbTextClone,
          tbTextShort: row.tbTextShortClone
        }
      )
      .subscribe((ret: any) => {
        if (ret.success) {
          this.modalService.showToast(
            'Textvorlage aktualisiert',
            'md-toast bg-green',
            'far fa-check'
          );
          this.loadTBData();
        } else {
          this.modalService.showToast(
            'Speichern fehlgeschlagen',
            'md-toast bg-red',
            'far fa-times'
          );
        }
      });
  }

  editorDelete(row: any): void {
    this.modalService
      .showSimple(
        'Textvorlage löschen',
        row.tbName + 'löschen?',
        true,
        true,
        'Löschen',
        'Abbrechen'
      )
      .subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.excRestService
            .delete(this.excRestService.computeUrl('UserTextbausteineD', {tbID: row.tbID}))
            .subscribe((ret: any) => {
              if (ret.success) {
                this.modalService.showToast(
                  'Textvorlage gelöscht',
                  'md-toast',
                  'far fa-trash'
                );
                this.loadTBData();
                this.userSettings.loadTextvorlagen();
              }
            });
        }
      });
  }
}
